import { render } from "./AccessDeniedView.vue?vue&type=template&id=0fbc4fbc"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__